module.exports = __webpack_public_path__ + "img/comment.1d700f4.png";